import React, { useCallback } from 'react';
import { CheckBoxParam, Form, SonForm, SubmitButton, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useInvalidateRefreshableBlock, useRefreshBlock } from '../../../_lib/BlockFetcher';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import { BlockType } from '../../../types/api/ElementType';
import { PrivilegeCheckboxTree } from './PrivilegeCheckboxTree';
import { BasicPrivilegeDependency } from '../PrivilegeConfig.types';

export type AdditionalPrivilegeCheckBoxParam = CheckBoxParam<'privileges'> & {
  dependentPrivileges: AdditionalPrivilegeCheckBoxParam[];
  requiredBasicPrivileges: BasicPrivilegeDependency[];
};

type AdditionalPrivilegeConfigEditFormProps = {
  form: SonForm<AdditionalPrivilegeCheckBoxParam>;
};

export function AdditionalPrivilegeConfigEditForm({ form }: AdditionalPrivilegeConfigEditFormProps) {
  const { t } = useSonTranslation('PrivilegeConfig');
  const { refresh } = useRefreshBlock();
  const { closeModal } = useModalContext();

  const invalidateRefreshableBlock = useInvalidateRefreshableBlock();
  const refreshAndClose = useCallback(() => {
    refresh();
    // we also want to refresh the basic privileges block.
    // see the asFetchableBlock call in BasicPrivilegeConfigBlock.tsx
    invalidateRefreshableBlock(BlockType.basicprivilegeconfig);
    closeModal();
  }, [closeModal, refresh, invalidateRefreshableBlock]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);

  const onSuccess = () => {
    delayedRefreshAndClose();
  };

  const { formProps, fetchState } = useForm({ form, onSuccess });

  return (
    <Form {...formProps}>
      {}
      <div className="privilege-config__multistep-content-container privilege-config__additional-privilege__checkbox-tree">
        <PrivilegeCheckboxTree privilegeParams={form.params as AdditionalPrivilegeCheckBoxParam[]} />
      </div>
      <SubmitButton
        buttonLabel={t('addPrivileges')}
        messageSuccess={t('message.success')}
        messageSending={t('message.sending')}
        messageFail={t('message.failure')}
        fetchState={fetchState}
        customErrorTypeMessages={{
          missingButRequired: t('message.missingAdditionalPrivilege'),
        }}
      />
    </Form>
  );
}
